<template>
  <header class="header-component">
    <router-link to="/" class="header-logo-link">
    <div class="header-logo"></div>
      <!-- <img v-ga="$ga.commands.trackEvent.bind(this, '/indexsch', 'S-sis_click')" class="header-logo" src="@/assets/synergies-logo.png" alt="logo"> -->
    </router-link>
    <!-- <div class="header-language">
      <a href="javascript:void(0)" class="header-link active">简</a>
      <span class="divider">|</span>
      <a href="javascript:void(0)" class="header-link">繁</a>
    </div> -->
  </header>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.header-component {
  height: 50px;
  position: fixed;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px;
  background-color: $theme-color-black;
  z-index: 999;
}

.header-logo-link {
  width: 140px;
}

.header-logo {
  background-image: url('../../assets/synergies-logo.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position-x: center;
  background-position-y: center;
  width: 140px;
  height: 28px;
}

.header-language {
  display: flex;
}

.header-link {
  text-decoration: none;
  color: $theme-color-primary;
  padding: 0 16px;

  &.active {
    color: $theme-color-white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue